
  <div *ngIf="historico">
  <div class="row">
    <div class="col">
      <h4>
        Histórico
        <small class="text-muted">(#ID: {{ historico.id }} -  {{historico.dataCriacao | date: 'dd/MM/yy HH:mm'}})</small>
      </h4>
    </div>

    <div class="col-auto">
      <button type="button" class="btn btn-primary" (click)="fecharHistorico()"> Fechar Histórico</button>
    </div>

  </div>


  <div class="row">
    <ul ngbNav #nav="ngbNav" class="col nav-tabs">

    <li ngbNavItem title="Dados Básicos">
        <button ngbNavLink>Dados Básicos</button>
        <ng-template ngbNavContent>
            <div class="row">
                <div class="bn-form-group col-md-3">
                    <label><b>Data do histórico</b></label>
                    <bn-datepicker name="dataCriacao" [(ngModel)]="historico.dataCriacao" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Usuário responsável</b></label>
                    <input class="form-control" name="nome" [(ngModel)]="historico.usuarioResponsavel" disabled>
                </div>
            </div>
            <div class="row">
                <div class="bn-form-group col-md-3">
                    <label><b>Nome:</b></label>
                    <input class="form-control" name="nome" [(ngModel)]="historico.nome" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Sigla:</b></label>
                    <input class="form-control" name="sigla" [(ngModel)]="historico.sigla" disabled>
                </div>
                <div class="bn-form-group col-md-6">
                    <label><b>Descrição:</b></label>
                    <input class="form-control" name="descricao" [(ngModel)]="historico.descricao" disabled>
                </div>
            </div>
            <div class="row">
                <div class="bn-form-group col-md-3">
                    <label><b>CNPJ resp. pelo fundo:</b></label>
                    <input class="form-control" name="cnpjResponsavelFundo"
                        [(ngModel)]="historico.cnpjResponsavelFundo" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Data res. diretoria criação do fundo.: <i class="fa fa-question-circle help-subtitulo"
                                placement="bottom"
                                ngbTooltip="Data resolução diretoria criação do fundo"></i></b></label>
                    <bn-datepicker name="dataResolucaoDiretoriaCriacaoFundo"
                        [(ngModel)]="historico.dataResolucaoDiretoriaCriacaoFundo" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Data limite última amortização <i class="fa fa-question-circle help-subtitulo"
                                placement="bottom"
                                ngbTooltip="A data limite de última amortização permitida para as operações nesta modalidade (se aplicável)"></i></b></label>
                    <bn-datepicker name="dataLimiteUltimaAmortizacao"
                        [(ngModel)]="historico.dataLimiteUltimaAmortizacao" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Nome valor crédito:</b></label>
                    <input class="form-control" name="nomeValorCredito" [(ngModel)]="historico.nomeValorCredito"
                        disabled>
                </div>

            </div>
            <div class="row">

                <div class="bn-form-group col-md-3">
                    <label><b>Prazo máx. env. lib. op. giro em dias: <i class="fa fa-question-circle help-subtitulo"
                                placement="bottom"
                                ngbTooltip="Prazo máximo envio liberação operação giro em dias"></i>
                        </b></label>
                    <input class="form-control" name="roleAssociada"
                        [(ngModel)]="historico.prazoMaximoEnvioLiberacaoOperacoesGiroEmDias" disabled>
                </div>

                <div class="bn-form-group col-md-3">
                    <label><b>E-mail do administrador: </b></label>
                    <input class="form-control" name="emailAdministrador"
                        [(ngModel)]="historico.emailAdministrador" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Número dec. dir. criação fundo.: <i class="fa fa-question-circle help-subtitulo"
                                placement="bottom"
                                ngbTooltip="Número decisão diretoria para criaç. de fundo:"></i></b></label>
                    <input class="form-control" name="numeroDecisaoDiretoriaCriacaoFundo"
                        [(ngModel)]="historico.numeroDecisaoDiretoriaCriacaoFundo" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Código sistema IPD: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                ngbTooltip="Código do evento para verificação de impedimentos no sistema IPD"></i></b></label>
                    <input class="form-control" name="codigoEventoIpd" [(ngModel)]="historico.codigoEventoIpd" disabled>
                </div>
            </div>
            <div class="row">
                <div class="bn-form-group col-md-3">
                    <label><b>Aceita operação de Crédito Livre:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante" name="aceitaOperacaoCreditoLivre"
                        [(ngModel)]="historico.aceitaOperacaoCreditoLivre" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Aceita operação Repasse SCC-15:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="aceitaOperacaoRepasseSistema15"
                        [(ngModel)]="historico.aceitaOperacaoRepasseSistema15" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Aceita operação Repasse SCC-89:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="aceitaOperacaoRepasseSistema89"
                        [(ngModel)]="historico.aceitaOperacaoRepasseSistema89" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Aceita modalidade de giro:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante" name="aceitaModalidadeGiro"
                        [(ngModel)]="aceitaModalidadeGiro" disabled>
                </div>
            </div>
            <div class="row">
                <div class="bn-form-group col-md-3">
                    <label><b>Aceita modalidade de investimento:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="aceitaModalidadeInvestimento" [(ngModel)]="historico.aceitaModalidadeInvestimento"
                        disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Aceita benef. PF - Crédito Livre:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="aceitaBeneficiarioPessoaFisicaCreditoLivre"
                        [(ngModel)]="historico.aceitaBeneficiarioPessoaFisicaCreditoLivre" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Aceita benef. PF - Crédito Livre:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="aceitaBeneficiarioPessoaFisicaRepasse"
                        [(ngModel)]="historico.aceitaBeneficiarioPessoaFisicaRepasse" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Utiliza SCR:
                            <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                ngbTooltip="Utiliza dados SCR na validação de solicitação de honra"></i></b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="utilizaDadosScrNaValidacaoDeSolicitacaoHonra"
                        [(ngModel)]="historico.utilizaDadosScrNaValidacaoDeSolicitacaoHonra" disabled>
                </div>
            </div>
            <div class="row">
                <div class="bn-form-group col-md-3">
                    <label><b>Cálculo tx. equivalente: <i class="fa fa-question-circle help-subtitulo"
                                placement="bottom"
                                ngbTooltip="Realiza cálculo de taxas equivalentes"></i></b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="realizaCalculoTaxasEquivalentes"
                        [(ngModel)]="historico.realizaCalculoTaxasEquivalentes" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>API externa habilitada: <i class="fa fa-question-circle help-subtitulo"
                                placement="bottom"
                                ngbTooltip="Indica se a API externa do Sistema está habilitada ou não para esta modalidade."></i></b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="aceitaUtilizacaoApiExternaFg2"
                        [(ngModel)]="historico.aceitaUtilizacaoApiExternaFg2" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Necessário tratamento lim. contrat.: <i class="fa fa-question-circle help-subtitulo"
                                placement="bottom"
                                ngbTooltip="Indica se o valor total do limite de contratação informado para as cestas desta modalidade necessita ser tratado pelo sistema (adição do valor das honras e subtração do valor das recuperações) ou se deverá ser utilizado tal qual informado."></i></b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="necessarioTratarValorTotalDosRecursosDaTranche"
                        [(ngModel)]="historico.necessarioTratarValorTotalDosRecursosDaTranche" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Permite aditivo substituição de beneficiário:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="permiteAditivoSubstituicaoBeneficiario"
                        [(ngModel)]="historico.permiteAditivoSubstituicaoBeneficiario" disabled>
                </div>
            </div>
            <div class="row">
                <div class="bn-form-group col-md-3">
                    <label><b>Utiliza relatório PENG:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante" name="utilizaRelatorioPENG"
                        [(ngModel)]="historico.utilizaRelatorioPENG" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Utiliza atualização info. acomp. process.:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="utilizaAtualizacaoInformacaoAcompanhamentoProcessual"
                        [(ngModel)]="historico.utilizaAtualizacaoInformacaoAcompanhamentoProcessual" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Utiliza atualização info. class. risco:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="utilizaAtualizacaoInformacaoClassificacaoRisco"
                        [(ngModel)]="historico.utilizaAtualizacaoInformacaoClassificacaoRisco" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Utiliza Remuneração Validação Limite Fundo:</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="utilizaRemuneracaoValidacaoLimiteFundo"
                        [(ngModel)]="historico.utilizaRemuneracaoValidacaoLimiteFundo" disabled>
                </div>
            </div>
            <div class="row" *ngIf="historico.utilizaDadosScrNaValidacaoDeSolicitacaoHonra">
                <div class="bn-form-group col-md-12">
                    <label><b>Mensagem aviso SCR:</b></label>
                    <textarea rows="6" class="form-control" name="mensagemAvisoSCR"
                        [(ngModel)]="historico.mensagemAvisoSCR" disabled></textarea>
                </div>
            </div>
            <div class="row">
                <div class="bn-form-group col-md-12">
                    <label><b>Termos de contratação:</b></label>
                    <textarea rows="6" class="form-control" name="termosContratacao"
                        [(ngModel)]="historico.termosContratacao" disabled></textarea>
                </div>
            </div>
            <div class="row">
                <div class="bn-form-group col-md-12">
                    <label><b>Termos envio devolucação de honra:</b></label>
                    <textarea rows="6" class="form-control" name="textoTermosEnvioDevolucaoHonra"
                        [(ngModel)]="historico.textoTermosEnvioDevolucaoHonra" disabled></textarea>
                </div>
            </div>
            <div class="row">
                <div class="bn-form-group col-md-12">
                    <label><b>Observação limite total:</b></label>
                    <textarea rows="6" class="form-control" name="textoObservacaoLimiteTotal"
                        [(ngModel)]="historico.textoObservacaoLimiteTotal" disabled></textarea>
                </div>
            </div>



        </ng-template>
    </li>

    <li ngbNavItem title="Cobrança">
        <button ngbNavLink>Cobrança</button>
        <ng-template ngbNavContent>

            <div class="row">
                <div class="bn-form-group col-md-3">
                    <label><b>Cód. coordenação ficha de cobrança:</b></label>
                    <input class="form-control" name="codigoCoordenacaoFichaCobranca"
                        [(ngModel)]="historico.codigoCoordenacaoFichaCobranca" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Cód. modalidade ficha de cobrança:</b></label>
                    <input class="form-control" name="codigoModalidadeFichaCobranca"
                        [(ngModel)]="historico.codigoModalidadeFichaCobranca" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Código fonte de recursos:</b></label>
                    <input class="form-control" name="codigoFonteRecursos"
                        [(ngModel)]="historico.codigoFonteRecursos" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Código tipo de contrato de honra:</b></label>
                    <input class="form-control" name="codigoTipoContratoHonra"
                        [(ngModel)]="historico.codigoTipoContratoHonra" disabled>
                </div>
            </div>

        </ng-template>
    </li>

    <!-- <li ngbNavItem title="Validação de Inadimplência">
        <button ngbNavLink>Validação de Inadimplência</button>
        <ng-template ngbNavContent>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="removeTopBorder" scope="col"><b>Modalidades para validação de inadimplência
                                    técnica&ensp;</b><i class="fa fa-question-circle help-subtitulo"
                                    placement="bottom"
                                    ngbTooltip="Modalidades nas quais deve ser verificada existência de inadimplência técnica."></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let item of historico.siglasModalidadesValidacaoInadimplenciaTecnica">
                        <td>{{item}}</td>
                    </tbody>
                </table>
            </div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col"><b>Modalidade para validação de inadimplência financeira&ensp;</b> <i
                                    class="fa fa-question-circle help-subtitulo" placement="bottom"
                                    ngbTooltip="Modalidades nas quais deve ser verificada existência de inadimplência financeira."></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let item of historico.siglasModalidadesValidacaoInadimplenciaFinanceira">
                        <td>{{item}}</td>
                    </tbody>
                </table>
            </div>
            <div class="row realizaValidacao">
                <div class="bn-form-group col-md-6">
                    <label><b>Validação de inadimplência financeira com o FGI tradicional (Sistema
                            legado):</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional"
                        [(ngModel)]="historico.realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional" disabled>
                </div>
            </div>

        </ng-template>
    </li> -->

    <li ngbNavItem title="Inadimplência AF">
        <button ngbNavLink>Inadimplência AF</button>
        <ng-template ngbNavContent>
            <div class="table-responsive mt-3">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="removeTopBorder" scope="col">
                                <b>Modalidades para validação de inadimplência técnica&ensp;</b>
                                <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                    ngbTooltip="Modalidades nas quais deve ser verificada existência de inadimplência técnica do Agente Financeiro.">
                                </i>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let item of historico.siglasModalidadesValidacaoInadimplenciaTecnica">
                        <td>{{item}}</td>
                    </tbody>
                </table>
            </div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="removeTopBorder" scope="col">
                                <b>Modalidades para validação de inadimplência financeira&ensp;</b>
                                <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                    ngbTooltip="Modalidades nas quais deve ser verificada existência de inadimplência financeira do Agente Financeiro.">
                                </i>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let item of historico.siglasModalidadesValidacaoInadimplenciaFinanceira">
                        <td>{{item}}</td>
                    </tbody>
                </table>
            </div>
            <div class="row realizaValidacao">
                <div class="bn-form-group col-md-6">
                    <label><b>Validação de inadimplência financeira do AF com o FGI tradicional (Sistema
                            legado):</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional"
                        [(ngModel)]="historico.realizaValidacaoInadimplenciaFinanceiraNoFgiTradicional" disabled>
                </div>
            </div>
        </ng-template>
    </li>

    <li ngbNavItem title="Inadimplência Beneficiário" id="inadimplencia_beneficiario">
        <button ngbNavLink>Inadimplência Beneficiário</button>
        <ng-template ngbNavContent>
            <div class="table-responsive mt-3">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="removeTopBorder" scope="col">
                                <b>Modalidades para validação de inadimplência financeira (beneficiário)&ensp;</b>
                                <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                    ngbTooltip="Modalidades nas quais deve ser verificada existência de inadimplência financeira de beneficiário.">
                                </i>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let item of historico.siglasModalidadesValidacaoInadimplenciaBeneficiario">
                        <td>{{item}}</td>
                    </tbody>
                </table>
            </div>
            <div class="row realizaValidacao">
                <div class="bn-form-group col-md-6">
                    <label><b>Validação de inadimplência financeira do Beneficiário com o FGI tradicional (Sistema
                            legado):</b></label>
                    <input type="checkbox" class="form-check checkbox-gigante"
                        name="realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional"
                        [(ngModel)]="historico.realizaValidacaoInadimplenciaBeneficiarioNoFgiTradicional" disabled>
                </div>
            </div>
        </ng-template>
    </li>


    <li ngbNavItem title="Outras Garantias">
        <button ngbNavLink>Outras Garantias</button>
        <ng-template ngbNavContent>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="removeTopBorder" scope="col"><b>Outras garantias permitidas</b></th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let item of historico.outrasGarantiasPermitidas">
                        <td>{{labelOutraGarantia(item)}}</td>
                    </tbody>
                </table>
            </div>

        </ng-template>
    </li>

    <li ngbNavItem title="Contas">
        <button ngbNavLink>Contas</button>
        <ng-template ngbNavContent>
            <div class="row">
                <div class="bn-form-group col-md-3">
                    <label><b>Conta pagamento de honra: <i class="fa fa-question-circle help-subtitulo"
                                placement="bottom"
                                ngbTooltip="Número da conta de contrapartida para pagamentos de honras"></i></b></label>
                    <input class="form-control" name="numeroContaContrapartidaPagamentoHonra"
                        [(ngModel)]="historico.numeroContaContrapartidaPagamentoHonra" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Conta recursos cobertura garantia: <i class="fa fa-question-circle help-subtitulo"
                                placement="bottom"
                                ngbTooltip="Número referente a conta de recursos de cobertura de garantia"></i></b></label>
                    <input class="form-control" name="numeroContaRecursosCoberturaGarantia"
                        [(ngModel)]="historico.numeroContaRecursosCoberturaGarantia" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Conta recebimento de ECG: <i
                                class="fa fa-question-circle help-subtitulo" placement="bottom"
                                ngbTooltip="Número da conta de contrapartida para recebimento de ECGs"></i></b></label>
                    <input class="form-control" name="numeroContaContrapartidaRecebimentoEcg"
                        [(ngModel)]="historico.numeroContaContrapartidaRecebimentoEcg" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Conta recebimento de Rec. de Crédito: <i
                                class="fa fa-question-circle help-subtitulo" placement="bottom"
                                ngbTooltip="Número da conta de contrapartida para recebimento de Recuperações de Crédito"></i></b></label>
                    <input class="form-control" name="numeroContaContrapartidaRecebimentoRecuperacaoCredito"
                        [(ngModel)]="historico.numeroContaContrapartidaRecebimentoRecuperacaoCredito" disabled>
                </div>
            </div>
        </ng-template>
    </li>

    <li ngbNavItem title="Percentuais Garantidos">
        <button ngbNavLink>Percentuais Garantidos</button>
        <ng-template ngbNavContent>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="removeTopBorder" scope="col">
                                <b>Percentuais Garantidos Permitidos</b>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let item of historico.percentuaisGarantiaPermitidos">
                        <td>{{item}}</td>
                    </tbody>
                </table>
            </div>
        </ng-template>
    </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>

